// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3YE8Y","text":"text__3YJL7","visible":"visible__2UOik","hidden":"hidden__37y9f","closeButton":"closeButton__3ThPp"};